import { getJSON, postJSON } from "@/lib/api"

export interface WaitlistEntry {
  id: string
  email: string
  name: string
  reason: string
  createdAt: string
  invitedAt: string | null
}

export const listWaitlistEntries = (): Promise<WaitlistEntry[]> =>
  getJSON("/v1/admin/waitlist")

export const inviteWaitlistEntry = (id: string): Promise<WaitlistEntry> =>
  postJSON(`/v1/admin/waitlist/${id}/invite`)
